<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="问卷详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">适用身份:</el-col>
        <el-col :span="19">{{ showForm.basic.roleList.join('，') }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">标题:</el-col>
        <el-col :span="19"><el-tag>{{ typehoods.find(e => e.value == showForm.typehood).label }}</el-tag> {{ showForm.title }}</el-col>
      </el-row>
      <el-row v-if="[1, 2, 3, 4].indexOf(showForm.typehood) > -1">
        <el-col :span="5">选项:</el-col>
        <el-col :span="19">
          <p v-for="item in showForm.basic.optionList" :key="item">{{item}}</p>
        </el-col>
      </el-row>
      <el-row v-if="showForm.typehood == 3">
        <el-col :span="5">星级描述:</el-col>
        <el-col :span="19">
          {{ showForm.basic.optionList.join('，') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">展示次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic.totalVisitCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">回复次数:</el-col>
        <el-col :span="19">
          {{ showForm.basic.totalRecordCount }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">备注:</el-col>
        <el-col :span="19">
          {{ showForm.basic.text || '无' }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">状态:</el-col>
        <el-col :span="19">
          <el-tag v-if="showForm.step === 1">待发布</el-tag>
          <el-tag v-if="showForm.step === 2" type="success">已发布</el-tag>
          <el-tag v-if="showForm.step === 3" type="danger">已下架</el-tag>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">创建时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">修改时间:</el-col>
        <el-col :span="19">
          {{ showForm.updated && moment(showForm.updated).format('YYYY-MM-DD HH:mm:ss') || '无' }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import typehoods from './typehood.config'
import { findQuest } from '@/api/alfmeier'
export default {
  name: 'AlfmeierQuestDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      typehoods,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const questId = row.questId
      this.row = row
      const data = await findQuest({
        questId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
